/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ad_Import_DescriptionInputs */

const en_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import completed AD generation jobs into your project.`)
};

const fr_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importez les tâches de génération de publicités terminées dans votre projet.`)
};

const de_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importieren Sie abgeschlossene AD-Generierungsaufträge in Ihr Projekt.`)
};

const it_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa i processi di generazione di annunci pubblicitari completati nel tuo progetto.`)
};

const ru_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортируйте завершенные задания по генерации AD в свой проект.`)
};

const es_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa los trabajos de generación de anuncios completados a tu proyecto.`)
};

const zh_cn2_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`将已完成的广告生成任务导入到您的项目中。`)
};

const ja_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`完了した広告生成ジョブをプロジェクトにインポートします。`)
};

const hi_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`पूर्ण हो चुके AD जनरेशन जॉब्स को अपने प्रोजेक्ट में आयात करें।`)
};

const pt_pt2_ad_import_description = /** @type {(inputs: Ad_Import_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importe os trabalhos de geração de anúncios (AD) concluídos para o seu projeto.`)
};

/**
* | output |
* | --- |
* | "Import completed AD generation jobs into your project." |
*
* @param {Ad_Import_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const ad_import_description = /** @type {((inputs?: Ad_Import_DescriptionInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ad_Import_DescriptionInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_ad_import_description(inputs)
	if (locale === "de") return de_ad_import_description(inputs)
	if (locale === "it") return it_ad_import_description(inputs)
	if (locale === "ru") return ru_ad_import_description(inputs)
	if (locale === "es") return es_ad_import_description(inputs)
	if (locale === "zh-CN") return zh_cn2_ad_import_description(inputs)
	if (locale === "ja") return ja_ad_import_description(inputs)
	if (locale === "hi") return hi_ad_import_description(inputs)
	if (locale === "pt-PT") return pt_pt2_ad_import_description(inputs)
	return en_ad_import_description(inputs)
});